export default __webpack_public_path__ + "static/media/card.51434b5e.svg";